import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const COMMISSION_CALCULATION_METHOD_SAVED = gql`
  subscription commissionCalculationMethodSaved {
    commissionCalculationMethodSaved {
      id
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const COMMISSION_CALCULATION_METHOD_DELETED = gql`
  subscription commissionCalculationMethodDeleted($methodId: Int!) {
    commissionCalculationMethodDeleted(methodId: $methodId) {
      id
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
